module.exports = __webpack_public_path__ + "img/bg_avatar_male_11.408b6a48.png";